
/* Initialize Angular Question App */
var questionApp = angular.module('questionApp', ['ngAnimate']);


/* Initialize the Main Controller for the Question App - location url:root/questions */
questionApp.controller('MainCtrl', function($scope, $http, $animate) {
	

	/* Initial variables */
	$scope.loadingmessage = "";
	$scope.answers = [];
	$scope.questions = [];
	$scope.qCounter = 0;
	$scope.rate = 0;
	$scope.source = '';
	$scope.showloader = false;
	$scope.choicesClass = [ '', '', '', '', ''];
	
	/* Retrive questions variable from intitial page request */
	$scope.questions = questions;

	/* Send answer for updating in scope and updating the important markers/counters (e.g. loading bar, active class for previous answer during back button) */
	$scope.sendAnswer = function($answer) {
		/* empty choices class*/
		$scope.choicesClass = [ '', '', '', '', ''];

		/* process the answer and update the conter */
		if($scope.qCounter <= $scope.questions.length) {
			$scope.answers[$scope.qCounter] = $answer;
			$scope.qCounter++;

			/* update the loading bar */
			$scope.rate = Math.ceil(($scope.qCounter / $scope.questions.length) * 100);

			/* if questions add questions are all answerd , then redirect to congratulations */
			if($scope.qCounter == $scope.questions.length) {
				$scope.loadingmessage = "Analyzing your answers. Please wait...";
				$scope.showloader = true;

				$('#answers').val($scope.answers);
				
				setTimeout(function() {
					$('#answers_form').submit();
				}, 3000);
				
			}
		}
		

	}

	/* function to return the marker to the previos question when back button is click */
	$scope.Back = function() {
		$scope.qCounter--;
		$scope.choicesClass = [ '', '', '', '', ''];
		$scope.choicesClass[$scope.answers[$scope.qCounter] - 1] = 'active';
		$scope.showsource = false;
		$scope.rate = Math.ceil(($scope.qCounter / $scope.questions.length) * 100);
		console.log($scope.choicesClass);
	}
	
});



/* Initialize Congratulation controller for Angular Question App - location url:root/congratulations */
questionApp.controller('Congratulation', function($scope, $http, $window, $location, questionProcess) {

	/* Initital Variable */
	$scope.processing = false;
	$scope.showloader = false;
	$scope.xhrDone = false;
	$scope.loaderDone = false;
	$scope.loadingmessage = "";
	$scope.timeOut = null;

	/* function to process the answers */
	$scope.processForm = function(formData) {
		$scope.processing = true;
		$scope.loadingmessage = "Processing Information";
		$scope.showloader = true;
		
		$scope.timeOut = setTimeout(function() {
			if($scope.xhrDone) {
				$window.location.href = "results";
			} else {
				$scope.loaderDone = true;
			}
		}, 3000);
		
		questionProcess.postResults(formData).then(function(response){
				if(response.status == 'error'){
				/* if response returns error display validation errors */
				$scope.processing = false;
				$scope.formData.error = true;
				$scope.formData.error_msg = response.validation.email[0];
				
				$scope.showloader = false;
				$scope.xhrDone = false;
				$scope.loaderDone = false;
				clearTimeout($scope.timeOut);
			}
			else{
				/* if response return false(sucess) redirect to the corresponding result page */
				$scope.formData.error = false;
								
				if($scope.loaderDone) {
					$window.location.href = "results";
				} else {
					$scope.responseContainer = response;
					$scope.xhrDone = true;
				}
			}
		});
		/* post the answers to url: root/get_results for back-end processing */
		// $http.post('getResults', formData).success(function(response){

		// 	if(response.status == 'error'){
		// 		/* if response returns error display validation errors */
		// 		$scope.processing = false;
		// 		$scope.formData.error = true;
		// 		$scope.formData.error_msg = response.validation.email[0];
				
		// 		$scope.showloader = false;
		// 		$scope.xhrDone = false;
		// 		$scope.loaderDone = false;
		// 		clearTimeout($scope.timeOut);
		// 	}
		// 	else{
		// 		/* if response return false(sucess) redirect to the corresponding result page */
		// 		$scope.formData.error = false;
								
		// 		if($scope.loaderDone) {
		// 			$window.location.href = "results";
		// 		} else {
		// 			$scope.responseContainer = response;
		// 			$scope.xhrDone = true;
		// 		}
		// 	}
		// });
	}
});

angular.module('questionApp').factory('questionProcess', function($http, $q){
	return {
		postResults: function(formData){
			var dfd = $q.defer();
			$http.post('getResults', formData).then(function(response){
				if(response){
					dfd.resolve(response);
				} else {
					dfd.resolve(false);
				}
			});
			return dfd.promise;
		}
	}
});
jQuery(document).ready(function($) {
	var t;
	$('.answer_item_wrap').on('click', function() {
		var el = this;
		clearTimeout(t);
		$('.active_answer').not(this).removeClass('active_answer');
		$(this).addClass('active_answer');
		t = setTimeout(function() {
			if($(el).hasClass('active_answer')) $(el).removeClass('active_answer');
		}, 500)
	});
});

//# sourceMappingURL=questions.js.map
